// Baixa a documentacao da API publica servida como estatico pelo backend
// (/docs/api-publica.md). O PDF e SEMPRE derivado do MD no navegador
// (pdfmake) — fonte unica, nunca commitar um PDF gerado.
import { saveAs } from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import apiUser from '../../apiUser';
import { mdParaPdfmake } from './mdParaPdfmake';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

async function obterDocMd() {
  // transformResponse identidade: axios tentaria fazer JSON.parse do .md
  const response = await apiUser.get('/docs/api-publica.md', {
    responseType: 'text',
    transformResponse: [(dados) => dados],
  });
  return response.data;
}

export async function baixarDocMd() {
  const md = await obterDocMd();
  saveAs(new Blob([md], { type: 'text/markdown;charset=utf-8' }), 'api-publica.md');
}

export async function baixarDocPdf() {
  const md = await obterDocMd();
  pdfMake.createPdf(mdParaPdfmake(md)).download('api-publica.pdf');
}
